import type { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { HtmlClassExtension } from '../../../extensions/html-class';
import { NodeName } from '../../../schema/nodes';

export class OrderedListNode implements NodeSpec {
  public static readonly nodeName = NodeName.OrderedList;
  public static is(node: ProsemirrorNode) {
    return node.type.name === OrderedListNode.nodeName;
  }
  private readonly htmlClassExtension?: HtmlClassExtension;
  public content = 'list_item+';
  public group = 'block';
  public attrs = {
    order: { default: 1 },
    ...(this.config?.withHtmlClass && HtmlClassExtension.attrs),
  };
  public parseDOM = [
    {
      tag: 'ol',
      getAttrs: (dom: HTMLElement) => ({
        order: dom.hasAttribute('start') ? parseInt(dom.getAttribute('start')!, 10) : 1,
        ...(this.htmlClassExtension && this.htmlClassExtension.parseDOMGetAttrs(dom)),
      }),
    },
  ];

  constructor(
    private config?: {
      withHtmlClass?: boolean;
    },
  ) {
    if (config?.withHtmlClass) {
      this.htmlClassExtension = new HtmlClassExtension();
    }
  }

  public toDOM = (node: ProsemirrorNode): DOMOutputSpec => {
    let attributes = {};
    if (this.htmlClassExtension) {
      const htmlClass = this.htmlClassExtension.getClassSerialization(node);
      if (htmlClass) {
        attributes = {
          ...attributes,
          class: htmlClass,
        };
      }
    }
    if (node.attrs.order !== 1) {
      attributes = {
        ...attributes,
        start: node.attrs.order,
      };
    }

    return !Object.keys(attributes).length ? ['ol', 0] : ['ol', attributes, 0];
  };
}
